
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SwingTendency } from '@/components/putting/training/charts/swing/SwingChartUtils';
import DriverDistanceCharts from "@/components/putting/training/charts/swing/DriverDistanceCharts";
import DriverPointsChart from "@/components/putting/training/charts/swing/DriverPointsChart";

interface DriverChartsSectionProps {
  tendencies: SwingTendency[];
  selectedLevel: string | null;
}

const DriverChartsSection: React.FC<DriverChartsSectionProps> = ({
  tendencies,
  selectedLevel
}) => {
  const { t } = useTranslation("training");
  // Filter tendencies based on the selected level
  const filteredTendencies = selectedLevel 
    ? tendencies.filter(t => t.test_level === selectedLevel)
    : tendencies;

  // Log for debugging
  useEffect(() => {
    console.log(`DriverChartsSection: Level filter changed to: ${selectedLevel}`);
    console.log(`DriverChartsSection: All tendencies: ${tendencies.length}`);
    console.log(`DriverChartsSection: Filtered tendencies: ${filteredTendencies.length}`);
    console.log(`DriverChartsSection: Tendencies by level:`, 
      tendencies.reduce((acc, t) => {
        const level = t.test_level || 'none';
        acc[level] = (acc[level] || 0) + 1;
        return acc;
      }, {} as Record<string, number>)
    );
  }, [selectedLevel, tendencies.length, filteredTendencies.length]);

  return (
    <>
      {/* Graphique d'évolution des points */}
      <div className="mb-10">
        <h3 className="text-lg font-bold mb-6 text-gray-800 px-1 border-l-4 border-green-500 pl-3">
          {t("driver.resultsEvolution")}
          {selectedLevel && <span className="ml-2 text-sm font-normal text-gray-600">(Niveau {selectedLevel})</span>}
        </h3>
        <DriverPointsChart 
          tendencies={filteredTendencies}
          selectedLevel={selectedLevel}
        />
      </div>
      
      {/* Tendances directionnelles */}
      <DriverDistanceCharts 
        driverResults={[]} 
        selectedLevel={selectedLevel}
        tendencies={filteredTendencies}
      />
    </>
  );
};

export default DriverChartsSection;
